import { Loading } from 'components/pages/loading/loading';

export default Loading;
